import PageShell from "@/components/PageShell";
import MerchantWallSection from "@/components/home/MerchantWallSection";

export default function MurPage() {
  return (
    <PageShell>
      <MerchantWallSection />
    </PageShell>
  );
}
